import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import type { ChatbotAction } from "./types";

export const convertRialToToman = (price: number, locale = "fa") =>
  numberConvert(numberSeparator(Math.floor(price / 10)), { locale });

export const getProductSelectTracking = (product: string) => ({
  tracking: {
    click: {
      event: "chatbot_product_selected",
      attributes: {
        product_type: product
      }
    }
  }
});

export const getProductSelectAction = (
  target: string
): { action: ChatbotAction } => ({
  action: {
    id: "flow.open_view",
    payload: {
      target
    }
  }
});
